import { useMemo } from "react";
import SpotifyService from "./SpotifyService";

export default function useSpotifyService() {
  return useMemo(() => new SpotifyService(), []);
}
